export class Environment {
  static production = true;
  public static encrypt = true;
  public static ENV = 'release';
  public static SYNC_URL = 'https://app-sync-au.platform.cardihab.com/v1/';
  public static CONTENT_METADATA = 'https://app-content.platform.cardihab.com';
  public static MOBILE_API = 'https://mobile-api-au.platform.cardihab.com';
  public static COMPANION_URL = 'https://companion.cardihab.com';
  public static CONTENT_URL = 'https://au.content.cardihab.com';
  public static HAPI_FHIR_URL = 'https://fhir-au.platform.cardihab.com';
  public static ONTOSERVER_URL = 'https://ontoserver-au.platform.cardihab.com/fhir';
  public static MEDICATIONS_SEARCH_SYSTEM = 'https://ontoserver-au.platform.cardihab.com/fhir';
  public static MEDICATIONS_VERSION = 'http://snomed.info/sct/32506021000036107?fhir_vs=refset/929360041000036105';
}
